import React, { useState } from 'react';
import CTextField from '@/components/ui/CTextField';
import PopoverMsg from '@/components/ui/PopoverMsg';
import { copyToClipboard } from '@/utils';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  Typography,
} from '@mui/material';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { CrashLatestGameItem } from '@/apis/casino/crash';
import { getMultiplier } from '@/components/features/casino/crash/utils';

import LocalizedLink from '@/components/ui/LocalizedLink';

interface CrashGameDetailProps {
  detail: CrashLatestGameItem;
}

const ResultPanel: React.FC<CrashGameDetailProps> = ({ detail }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const router = useRouter();
  const handleCopy = (content, e) => {
    copyToClipboard(content).then(() => {
      setAnchorEl(e.target.parentNode);
      setTimeout(() => {
        setAnchorEl(null);
      }, 1000);
    });
  };

  const goToFairness = () => {
    router.push('/casino/fairness');
  };

  return (
    <Box>
      <PopoverMsg anchorEl={anchorEl}></PopoverMsg>
      <Typography
        variant="h6"
        sx={{ mt: 2, textAlign: 'center', fontSize: '20px!important' }}
      >
        {getMultiplier(Number(detail.result))}
      </Typography>
      <Box
        sx={{
          backgroundColor: (theme) => theme.palette.grey[950],
          p: 3,
          borderRadius: 1,
          mt: 3,
        }}
      >
        {/*hash*/}
        <FormControl fullWidth margin="dense">
          <Typography sx={{ mb: 1 }} variant="body2" component="span">
            {t('Hash')}
          </Typography>
          <CTextField
            value={detail.hash}
            fullWidth
            disabled
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={(e) => handleCopy(detail.hash, e)}
                    edge="end"
                  >
                    <ContentCopyIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </FormControl>
        {/*seed*/}
        <FormControl fullWidth margin="dense">
          <Typography sx={{ mb: 1 }} variant="body2" component="span">
            {t('Seed')}
          </Typography>
          <CTextField
            value={detail.seed}
            fullWidth
            disabled
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={(e) => handleCopy(detail.seed, e)}
                    edge="end"
                  >
                    <ContentCopyIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </FormControl>

        <FormControl fullWidth margin="dense" sx={{ mt: 2 }}>
          <LocalizedLink href={'/casino/fairness'} target={'_blank'}>
            <Button
              fullWidth
              variant={'text'}
              sx={{
                fontFamily: 'Readex Pro',
              }}
            >
              {t('What is Provable Fairness?')}
            </Button>
          </LocalizedLink>
        </FormControl>
      </Box>
    </Box>
  );
};

export default ResultPanel;
